import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

/**
 * Closes the slot between the last tread and the slab: the last tread butts against the slab
 * edge, and when the slab is thinner than one rise plus the tread, a riser under the slab fills
 * the rest. Only where the slab really continues past the exit — an exit at a room wall or
 * inside the opening has nothing to close.
 */
export function applyExitRiser(lastStep: IStepGeometry | undefined, config: IStairConfig, slabPastExit: boolean): void {
    if (!lastStep || !slabPastExit) {
        return;
    }
    const height: number = config.floorHeight - (lastStep.position.y - config.treadThickness);
    if (height > 0) {
        lastStep.exitRiserHeight = height;
    }
}
